import React, { useState, useEffect } from 'react';
import { InputGroup, Input, Form, Label, Button, FormGroup, Row, Col } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import {
  guestUser,
  updateInputs,
  updateRadioBox,
  verifyUser,
  setShippingMethod,
} from '../actions/checkOutActions';
import { connect } from 'react-redux';
import classnames from 'classnames';
import ButtonSpinner from './ButtonSpinner';
import { logoutUser } from '../actions/formActions';

const UserInfo = ({
  checkout,
  shoppingCart,
  auth,
  guest,
  nextStep,
  previousStep,
  logoutUser,
  guestUser,
  updateInputs,
  updateRadioBox,
  verifyUser,
  setShippingMethod,
}: any) => {
  const history = useHistory();
  const [newAddress, setNewAddress] = useState(true);
  const [windowWidth, setWindowWidth] = useState(0);

  const updateWindowDimension = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    window.addEventListener('resize', updateWindowDimension);

    if (auth.isAuthenticated) {
      if (auth.user.firstName) {
        updateInputs('firstname', auth.user.firstName);
      }
      if (auth.user.lastName) {
        updateInputs('lastname', auth.user.lastName);
      }
      if (auth.user.email) {
        updateInputs('email', auth.user.email);
      }
      if (auth.user.adress.length !== 0) {
        let defaultAddress = auth.user.adress.filter(
          (eachAdress) => eachAdress.addressType === 'default'
        );

        let address = defaultAddress[0].streetAdress;
        let suburb = defaultAddress[0].suburb;
        let postcode = defaultAddress[0].zipCode;
        updateInputs('address', address);
        updateInputs('suburb', suburb);
        updateInputs('postcode', postcode);

        setNewAddress(false);
      }
      if (auth.user.phoneNumber) {
        updateInputs('phoneNumber', auth.user.phoneNumber.replace(/\s/g, ''));
      }
    }

    return () => {
      window.removeEventListener('resize', updateWindowDimension);
    };
  }, []);

  useEffect(() => {
    if (!checkout.buttonLoading && Object.keys(checkout.errors).length === 0) {
      // only trigger after buttonLoading turns false (not on initial render)
    }
  }, [checkout.buttonLoading]);

  // Replicate componentDidUpdate: when buttonLoading flips to false with no errors, advance
  const prevButtonLoadingRef = React.useRef(checkout.buttonLoading);
  useEffect(() => {
    if (
      prevButtonLoadingRef.current !== checkout.buttonLoading &&
      !checkout.buttonLoading &&
      Object.keys(checkout.errors).length === 0
    ) {
      nextStep();
    }
    prevButtonLoadingRef.current = checkout.buttonLoading;
  }, [checkout.buttonLoading]);

  const onChange = (e) => {
    var field = e.target.name;
    var inputValue = e.target.value;
    updateInputs(field, inputValue);
    if (!newAddress) {
      setNewAddress(true);
    }
  };

  const nextStepHandler = (e) => {
    e.preventDefault();

    if (checkout.email === 'roar_monthly@hotmail.com') {
      alert('Unknown error occurred, please try again later');
      return;
    }

    if (!auth.isAuthenticated) {
      var guestUserData = {
        email: checkout.email,
        firstname: checkout.firstname,
        lastname: checkout.lastname,
        sendOffers: checkout.sendOffers,
        zipCode: checkout.postcode,
        cart: shoppingCart.cart,
        guestUser: checkout.guestUser,
        streetAdress: checkout.address,
        suburb: checkout.suburb,
        shippingMethod: checkout.shippingMethod,
        phoneNumber: checkout.phoneNumber.replace(/\s/g, ''),
        tempCartId: guest.userid || undefined,
      };
      guestUser(guestUserData);
    } else {
      var userData = {
        user: auth.user.id,
        zipCode: checkout.postcode,
        streetAdress: checkout.address,
        suburb: checkout.suburb,
        email: checkout.email,
        firstname: checkout.firstname,
        lastname: checkout.lastname,
        newAddress,
        shippingMethod: checkout.shippingMethod,
        phoneNumber: checkout.phoneNumber.replace(/\s/g, ''),
      };

      verifyUser(userData);
    }
  };

  const handleRadioBox = () => {
    updateRadioBox(!checkout.sendOffers);
  };

  const handleSavedAdress = (e) => {
    let val = e.target.value;

    if (val === 'new address') {
      updateInputs('address', '');
      updateInputs('suburb', '');
      updateInputs('postcode', '');
      if (!newAddress) {
        setNewAddress(true);
      }
    } else {
      let selectedAddress = auth.user.adress.filter((eachAdress) => eachAdress._id === val);
      let address = selectedAddress[0].streetAdress;
      let suburb = selectedAddress[0].suburb;
      let postcode = selectedAddress[0].zipCode;
      updateInputs('address', address);
      updateInputs('suburb', suburb);
      updateInputs('postcode', postcode);

      if (newAddress) {
        setNewAddress(false);
      }
    }
  };

  const onLogoutClick = () => {
    logoutUser();
    history.push('/login');
  };

  const buttonDisabled = () => {
    return checkout.shippingMethod === 'delivery'
      ? checkout.buttonLoading ||
          checkout.email === '' ||
          checkout.firstname === '' ||
          checkout.lastname === '' ||
          checkout.address === '' ||
          checkout.suburb === '' ||
          checkout.postcode === '' ||
          checkout.phoneNumber === ''
      : checkout.shippingMethod === 'pickup' &&
          (checkout.email === '' ||
            checkout.firstname === '' ||
            checkout.lastname === '' ||
            checkout.phoneNumber === '');
  };

  return (
    <div className="container py-4" style={{ maxWidth: 650 }}>
      <div className="">
        <h5 className="text-left " style={{ fontSize: '1.28571em' }}>
          Contact Information
          {!auth.isAuthenticated && (
            <span className="float-right " style={{ fontSize: '14px', paddingTop: 5 }}>
              <a href="/login" className="text-muted">
                {' '}
                Already have an account? Log in
              </a>
            </span>
          )}
        </h5>
        {!auth.isAuthenticated ? (
          <Form className="pt-2">
            <InputGroup>
              <Input
                className={classnames('', {
                  'is-invalid': checkout.errors.email,
                })}
                placeholder="Email*"
                type="email"
                onChange={onChange}
                value={checkout.email}
                name="email"
              />
              <div className="invalid-feedback">{checkout.errors.email}</div>
            </InputGroup>

            <InputGroup className="pl-4 pt-2">
              <Label check>
                <Input type="checkbox" id="offers" onClick={handleRadioBox} />
                Keep me up to date on news and exclusive offers
              </Label>
            </InputGroup>
          </Form>
        ) : (
          <div className="pt-2">
            <div style={{ display: 'table-cell' }}>
              <i
                className="far fa-user fa-2x  p-3 text-muted"
                style={{ borderRadius: 15, border: '2px solid' }}
              ></i>
            </div>
            <p style={{ display: 'table-cell', verticalAlign: 'middle' }}>
              <span className="px-2">
                {auth.user.firstName} {auth.user.lastName}
              </span>
              <span>({auth.user.email})</span>
              <br />
              <a
                href="#"
                style={{ cursor: 'pointer' }}
                onClick={onLogoutClick}
                className="px-2 checkout-logout"
              >
                Log out
              </a>
            </p>
          </div>
        )}
      </div>

      <div className="mt-3">
        {checkout.shippingMethod === 'delivery' && (
          <h5 className="text-left" style={{ fontSize: '1.28571em' }}>
            Shipping Address
          </h5>
        )}
        {checkout.shippingMethod === 'pickup' && (
          <h5 className="text-left" style={{ fontSize: '1.28571em' }}>
            Pick-up Details
          </h5>
        )}
        <Form className="pt-3">
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Input
                  className={classnames('', {
                    'is-invalid': checkout.errors.firstname,
                  })}
                  placeholder="First Name*"
                  type="text"
                  onChange={onChange}
                  value={checkout.firstname}
                  name="firstname"
                />
                <div className="invalid-feedback">{checkout.errors.firstname}</div>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Input
                  className={classnames('', {
                    'is-invalid': checkout.errors.lastname,
                  })}
                  placeholder="Last Name*"
                  type="text"
                  onChange={onChange}
                  value={checkout.lastname}
                  name="lastname"
                />
                <div className="invalid-feedback">{checkout.errors.lastname}</div>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Input
                  className={classnames('', {
                    'is-invalid': checkout.errors.phoneNumber,
                  })}
                  placeholder="Phone Number*"
                  type="text"
                  onChange={onChange}
                  value={checkout.phoneNumber}
                  name="phoneNumber"
                />
                <div className="invalid-feedback">{checkout.errors.phoneNumber}</div>
              </FormGroup>
            </Col>
          </Row>
          {auth.isAuthenticated &&
            auth.user.adress.length !== 0 &&
            checkout.shippingMethod === 'delivery' && (
              <FormGroup>
                <Label for="saved-addresses">Saved Addresses</Label>
                <Input
                  type="select"
                  name="saved-addresses"
                  id="saved-addresses"
                  onChange={handleSavedAdress}
                >
                  {auth.user.adress.map((eachAdress) => (
                    <option value={eachAdress._id} key={eachAdress._id}>
                      {eachAdress.streetAdress} {eachAdress.suburb} {eachAdress.zipCode} Victoria
                    </option>
                  ))}
                  <option value="new address">Use a new address</option>
                </Input>
              </FormGroup>
            )}

          {checkout.shippingMethod === 'delivery' && (
            <React.Fragment>
              <FormGroup>
                <Input
                  disabled={!newAddress}
                  placeholder="Address*"
                  type="text"
                  onChange={onChange}
                  value={checkout.address}
                  name="address"
                />
              </FormGroup>

              <FormGroup>
                <Input
                  disabled={!newAddress}
                  placeholder="Suburb*"
                  type="text"
                  onChange={onChange}
                  value={checkout.suburb}
                  name="suburb"
                />
              </FormGroup>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Input
                      placeholder="State*"
                      type="text"
                      onChange={onChange}
                      value="Victoria"
                      disabled={true}
                      name="region"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Input
                      disabled={!newAddress}
                      className={classnames('', {
                        'is-invalid': checkout.errors.postcode,
                      })}
                      placeholder="Postal Code*"
                      type="text"
                      onChange={onChange}
                      value={checkout.postcode}
                      name="postcode"
                    />
                    <div className="invalid-feedback">{checkout.errors.postcode}</div>
                  </FormGroup>
                </Col>
              </Row>
            </React.Fragment>
          )}
          <FormGroup>
            <Input
              type="textarea"
              rows="8"
              placeholder="Please add any notes regarding you order"
              onChange={onChange}
              value={checkout.description}
              name="description"
            />
          </FormGroup>
        </Form>
        <Row>
          <Col>
            <Button
              disabled={checkout.buttonLoading}
              size="sm"
              color="dark"
              outline
              className="border-0 font-weight-bold"
              onClick={previousStep}
            >
              &lt; Shipping
            </Button>
          </Col>
          <Col className="text-right " style={{ marginRight: windowWidth < 500 && 50 }}>
            <Button
              size="sm"
              disabled={buttonDisabled()}
              color="success"
              onClick={nextStepHandler}
              style={{ minWidth: 182 }}
            >
              {checkout.buttonLoading ? <ButtonSpinner /> : <span> Continue to Payment &gt;</span>}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  checkout: state.checkout,
  shoppingCart: state.cart,
  guest: state.guest,
  auth: state.form,
});

export default connect(mapStateToProps, {
  logoutUser,
  guestUser,
  updateInputs,
  updateRadioBox,
  verifyUser,
  setShippingMethod,
})(UserInfo);
